import HeaderImage from './HeaderImage';

export default HeaderImage;
